import React from 'react';

const tools: { name: string; logo: string; url: string }[] = [
  { name: 'React', logo: 'https://cdn.simpleicons.org/react/61DAFB', url: 'https://react.dev' },
  { name: 'TypeScript', logo: 'https://cdn.simpleicons.org/typescript/3178C6', url: 'https://www.typescriptlang.org' },
  { name: 'Node.js', logo: 'https://cdn.simpleicons.org/nodedotjs/339933', url: 'https://nodejs.org' },
  { name: 'Supabase', logo: 'https://cdn.simpleicons.org/supabase/3FCF8E', url: 'https://supabase.com' },
  { name: 'n8n', logo: 'https://cdn.simpleicons.org/n8n/EF3D3D', url: 'https://n8n.io' },
  { name: 'Azure', logo: 'https://cdn.simpleicons.org/microsoftazure/0089D6', url: 'https://azure.microsoft.com' },
  { name: 'OpenAI', logo: 'https://cdn.simpleicons.org/openai/412991', url: 'https://platform.openai.com' },
  { name: 'Claude (Anthropic)', logo: 'https://cdn.simpleicons.org/anthropic/000000', url: 'https://www.anthropic.com' },
  { name: 'Google Tag', logo: 'https://cdn.simpleicons.org/googletagmanager/246FDB', url: 'https://tagmanager.google.com' },
  { name: 'GA4', logo: 'https://cdn.simpleicons.org/googleanalytics/E37400', url: 'https://marketingplatform.google.com/about/analytics/' },
  { name: 'Meta', logo: 'https://cdn.simpleicons.org/meta/0467DF', url: 'https://about.meta.com' },
  { name: 'WhatsApp Business', logo: 'https://cdn.simpleicons.org/whatsapp/25D366', url: 'https://business.whatsapp.com' },
  { name: 'Microsoft Office', logo: 'https://cdn.simpleicons.org/microsoftoffice/D83B01', url: 'https://www.microsoft.com/microsoft-365' }
];

export const ToolShowcase: React.FC = () => {
  return (
    <section className="relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-6 md:p-8 shadow-sm">
          <p className="text-xs font-semibold text-slate-500 dark:text-gray-400 mb-3 text-center">Workflow & Tooling</p>
          <h3 className="text-xl md:text-2xl font-bold text-slate-900 dark:text-gray-100 text-center">Stack operativo che uso ogni settimana</h3>
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 items-center">
            {tools.map((t) => (
              <a key={t.name} href={t.url} target="_blank" rel="noreferrer" className="group flex items-center gap-2 rounded-lg border border-slate-200 dark:border-gray-700 bg-slate-50 dark:bg-gray-700/50 p-3 hover:bg-white dark:hover:bg-gray-700 transition-colors">
                <img src={t.logo} alt={t.name} className="w-5 h-5" />
                <span className="text-sm text-slate-700 dark:text-gray-300 group-hover:text-slate-900 dark:group-hover:text-gray-100">{t.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToolShowcase;


